<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>干部培训课程质量评估</span>
        </div>
        <router-link to="clazzEvaluation">
        <span class="subtitle">干部教学培训质量评估</span>
        </router-link>
      </div>
      <div class="body_content class_body_content">
        <div class="searcharea">
          <input type="text" class="form-control" name="chooseStartDate" style="width: 200px;display: inline-block;" placeholder="课程名称、主讲教师" v-model="name">
          <button type="button" class="btn btn-default btn_option" style="height: 28px;line-height: 15px;" @click="initEvaluationListData()">查询</button>
          <button type="button" class="btn btn-default btn_option"
                  style="height: 28px;line-height: 15px"
                  @click="exportEvaluationInfo()">导出</button>
        </div>

        <div id="showme_details" class="float_deteils_div" :class="{isShowDivClass: isShowDiv}">
          <div class="scroeDetail classEvaluationScore">
            <p v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')"><b>{{q.title}}:</b>{{studentScoreDetailsrespList['item'+(i+1)]}}</p>
          </div>
        </div>


        <div class="class_body_content_self">
          <table class="table table-striped table-bordered tbl_evaluation">
            <thead>
            <tr>
              <th class="tablexuhao" width="5%">序号</th>
              <th width="20%">课程名称</th>
              <th width="15%">主讲老师</th>
              <th width="10%">培训日期</th>
              <th width="15%">已评估人数/总评估人数</th>
              <th width="10%">综合平均分</th>
              <th width="10%">其它意见个数</th>
              <th width="10%">详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(clazzEvaluation,index) in clazzEvaluationList" :key="index">
              <td width="5%">{{index+1}}</td>
              <td width="20%">{{clazzEvaluation.name}}</td>
              <td width="15%">{{clazzEvaluation.teacherName}}</td>
              <td width="10%">{{clazzEvaluation.startDate}}</td>
              <td width="15%">{{clazzEvaluation.contentNum}}/{{clazzEvaluation.numStudent}}</td>
              <td width="10%">{{clazzEvaluation.score}}</td>
              <td width="10%">{{clazzEvaluation.contentNums}}</td>
              <td width="10%">
                <div class="details_pic" @click="getDetails(clazzEvaluation)"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">
              <span>《{{details_lesson_name}}》干部培训课程质量评估</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="evaluation teacher_introduce">
              <b>主讲：</b>{{details_teacher_name}}
              <b>日期：</b>{{details_startDate_name}}
              <b>评估人数：</b>{{details_numStudent_name}}
              <!--<b>type:</b>{{details_type}}-->
            </div>
            <div class="evaluation evaluation_all">
              <table class="table table-striped table-bordered">
                <thead>
                <tr v-if="currentQuestionnaire.filter(i=>i.type=='1').length>0">
                  <th v-for="q in currentQuestionnaire" v-if="q.type == '1'" :colspan="q.colspan">{{q.title}}（{{q.maxValue}}）</th>
                  <th></th>
                </tr>
                <tr>
                  <th v-for="q in currentQuestionnaire" v-if="q.type != '1'">{{q.title}}（{{q.maxValue}}）</th>
                  <th>总分（{{ totalScore }}）</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(clazzEvaluation,index) in studentEvaluationAvgList" :key="index">
                  <td v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')" v-if="q.type != '1'">{{clazzEvaluation['item'+(i+1)]}}</td>
                  <td>{{clazzEvaluation.score}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="evaluation evaluation_details">
              <table class="table table-striped table-bordered other_tab">
                <thead>
                <tr>
                  <th width="20%">评估学员</th>
                  <th width="10%">总给分（100）</th>
                  <th width="60%">其他建议</th>
                  <th width="10%">详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(studentEvalua,index) in studentEvaluationList" :key="index">
                  <td width="20%">**</td>
                  <td width="10%">{{studentEvalua.score}}</td>
                  <td width="60%">{{studentEvalua.content}}</td>
                  <td width="10%">
                    <div class="details_pic" v-on:mouseover="student_id=studentEvalua.id;getStudentScoreDetails($event)" v-on:mouseout="isShowDiv=false"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';

  export default {
    name: "teachingEvaluation",
    data(){
      return{
        clazzId: this.$store.state.clazzId,
        clazzEvaluationList: [],
        studentEvaluationAvgList: [],
        studentEvaluationList: [],
        studentScoreDetailsrespList: {},

        page:'',
        rows:'',
        type:'',

        details_lesson_id: '',
        details_lesson_name: '',
        details_teacher_name: '',
        details_startDate_name: '',
        details_numStudent_name: '',
        details_type:'',

        student_id: '',

        name:'',

        isShowDiv: false,

        checkbox: {
          checkIds: [],
        },
        currentQuestionnaireId:"",
        currentQuestionnaire:[],

        token: this.$store.state.access_token,
        serviceBase:this.$store.state.serviceBase,
        hrefExport:this.$store.state.serviceBase+"resources/",
        totalScore:0
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initEvaluationListData();
      });
    },
    methods: {
      initEvaluationListData() {
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'evaluate/findClazzPage',
          data: {
            clazzId: this_.clazzId,
            name: this_.name,
            page: '1',
            rows: '9999'
          }
        }).then(function (resp) {
          /* console.log(resp)*/
          this_.clazzEvaluationList = resp.data.list;
        });
      },

      initEvaluationTemplate(id, callback){
        if(this.currentQuestionnaireId == id){
          if(callback) callback.call(this);
          return;//同一评估ID跳过
        }
        this.currentQuestionnaireId = id;
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'questionnaire/getItemlistById',
          params: {
            id: id
          }
        }).then(function (resp) {
          if(resp.data.success){
            this_.currentQuestionnaire = resp.data.list;
            let colspan = 0
            let cItem;
            this_.totalScore = 0;
            this_.currentQuestionnaire.forEach(item => {
              if(item.type == '1'){
                if(cItem && colspan) {
                  cItem.colspan = colspan;
                }
                colspan = 0;
                cItem = item;
              }else{
                colspan ++;
                this_.totalScore += Number(item.maxValue)
              }
            })
            if(cItem && colspan){
              cItem.colspan = colspan;
            }
            if(callback) callback.call(this);
          }
        });
      },
      /**
       * 查询详情
       */
      getDetails(clazzEvaluation){
        this.details_lesson_id=clazzEvaluation.id;
        this.details_lesson_name=clazzEvaluation.name;
        this.details_teacher_name=clazzEvaluation.teacherName;
        this.details_startDate_name=clazzEvaluation.startDate;
        this.details_numStudent_name=clazzEvaluation.contentNum;
        let this_ = this;
        this_.details_type=clazzEvaluation.type;
        // if(this_.details_type == 1){
        this.initEvaluationTemplate(clazzEvaluation.questionnaireId, function (){

          schoolAxios({
            method: 'get',
            url: 'evaluate/getLessonEvaluateMsg',
            params: {
              teacherId: clazzEvaluation.teacherId,
              lessonId: clazzEvaluation.id
            }
          }).then(function (studentresp) {
            if(studentresp.data.success){
              this_.studentEvaluationAvgList = studentresp.data.list;
            }
          });
          schoolAxios({
            method: 'get',
            url: 'evaluate/StudentEvaluateMsg',
            params: {
              teacherId: clazzEvaluation.teacherId,
              lessonId: clazzEvaluation.id
            }
          }).then(function (studentresp) {
            if(studentresp.data.success){
              this_.studentEvaluationList = studentresp.data.list;
            }
          });
        });
        // }else {
        //   schoolAxios({
        //     method: 'get',
        //     url: 'evaluate/getLessonEvaluateMsg',
        //     params: {
        //       dataId: this_.clazzId
        //     }
        //   }).then(function (studentresp) {
        //     if(studentresp.data.success){
        //       this_.studentEvaluationAvgList = studentresp.data.list;
        //     }
        //   });
        //   schoolAxios({
        //     method: 'get',
        //     url: 'evaluate/StudentEvaluateMsg',
        //     params: {
        //       dataId: this_.clazzId
        //     }
        //   }).then(function (studentresp) {
        //     if(studentresp.data.success){
        //       this_.studentEvaluationList = studentresp.data.list;
        //     }
        //   });
        // }

        $("#myModal").modal("show");
      },
      getStudentScoreDetails(event){
        if(this.isShowDiv) return;
        this.isShowDiv = true;
        $("#showme_details").css("left", event.pageX-120).css("top", event.pageY-150);
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'evaluate/load/'+this_.student_id,
          params: {
          }
        }).then(function (studentScoreDetailsresp) {
          /*console.log(studentScoreDetailsresp)*/
          if(studentScoreDetailsresp.data.success){
            this_.studentScoreDetailsrespList = studentScoreDetailsresp.data.data;
            $("#myModal").modal("show");
          }
        });
      },
      /**
       * 导出
       */
      exportEvaluationInfo(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'evaluate/clazzEvaluateExcelExport',
          params: {
            "clazzId":this_.clazzId,
            "name": this_.name
          }
        }).then(function (response) {
          if(response.data.success){
            location.href=this_.hrefExport+response.data.data;
          }else {
            (response.data.message||"导出数据失败").showMessage();
          }
        });
        /*if(ids){
          location.href=this_.serviceBase+"evaluate/clazzEvaluateExcelExport?access_token="+this_.token+'&clazzId='+this_.clazzId+'&ids='+this_.checkbox.checkIds.toString();
        }else{
          "请勾选导出数据".showMessage();
        }*/
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .table {
    color: #FFFFFF;
  }
  .table th {
    color: black;
    background-color: #cccccc;
  }
  .table tr{
    color: black;
    background-color: #FFFFFF;
  }
  .table,.table th {
    text-align: center;
  }
  /*.tabletd{
    width: 140px;
  }
  .tablexuhao{
    width: 90px;
  }*/
  .class_body_content_self {
    width: 100%;
    height: auto;
    /*margin-top: 30px;*/
  }
  .details_pic {
    margin: auto;
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/teachingEvaluation/details_disabled.png");*/
    background-image: url("../assets/img/right/clazz/details_mouseOver.png");
    background-size: 100% 100%;
  }
  /*.details_pic:hover{
    background-image: url("../img/right/teachingEvaluation/details_mouseOver.png");
  }*/

  .modal-dialog {
    width: 60%;
    /*height: 80%;*/
  }
  .modal-content {
    width: 100%;
    /*height: 100%;*/
  }
  .modal-title {
    text-align: center;
  }
  .modal-header {
    height: 8%;
  }
  .modal-body {
   /* height: 92%;*/
  }

  .teacher_introduce {
    width: 100%;
    height: 6%;
  }
  .evaluation_all {
    width: 100%;
    height: 16%;
  }
  .evaluation_details {
    width: 100%;
    /*height: 78%;*/
    overflow: auto;
  }
  .evaluation_details table {
    width: 100%;
    /*max-height: 96%;*/
    overflow: auto;
  }

  .float_deteils_div {
    padding: 20px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 150px;
    overflow: hidden;
    z-index: 2000;
    background-color: white;
    display: none;
    border: 1px solid black;
  }
  .isShowDivClass {
    display: block;
  }
  .scroeDetail{
    text-align: center;
  }
  .classEvaluationScore {
    overflow: hidden;
  }

  /*
  .other_tab tr td {
    height: 40px;
  }
  */


  /*教学评估列表表头固定*/
  .tbl_evaluation thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_evaluation tbody{
    /*display: block;
    height: 450px;*/
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .tbl_evaluation tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_evaluation{
    border: none;
  }
  .tbl_evaluation tbody::-webkit-scrollbar{
    width:0;
  }

  /*教学评估模态框表头固定*/
  .other_tab thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .other_tab tbody{
    /*display: block;*/
    /*height: 450px;*/
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .other_tab tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .other_tab{
    border: none;
  }
  .other_tab tbody::-webkit-scrollbar{
    width:0;
  }
  .searcharea{
    margin: 10px;
  }
  .subtitle{
    display: inline-block;
    font-size: 14px;
    color: #3c3c3c;
    line-height: 40px;
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/teachingEvaluation.vue